// extracted by mini-css-extract-plugin
export default {"separator":"PageToolbarSeparator-separator-N1WHF"};